import { includes, reduce } from 'lodash';

import formData from './form-data-config';

const DEFAULT_FILTER = 'wholeHouse';
export const form = 'generatorNeeds';

const appliances = reduce(
  formData.appliances.fields,
  (agg, appliance) => ({
    ...agg,
    ...(includes(appliance.preselect, DEFAULT_FILTER) && { [appliance.label]: 1 }),
  }),
  {},
);

const defaultConfig = {
  form,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  initialValues: {
    'Appliance Filter': DEFAULT_FILTER,
    appliances,
  },
};

if (process.env.NODE_ENV === 'development') {
  defaultConfig.initialValues = {
    ...defaultConfig.initialValues,
    'Zip Code': '32615',
    'Square Footage': '4000',
  };
}

export default defaultConfig;



// WEBPACK FOOTER //
// ./src/views/Home/components/configs/generator-needs-form-config.js